import httpManager from "../../../shared/utils/httpManager";

/**
 * Modificar secuencia de contacto.
 *
 * @param {Number} id
 * @return {Promise<Object>} Contacto
 */
export async function updateSequenceContact(id, sequence_id) {
  const body = {
    sequence: sequence_id,
  };
  const url = `/contacts/clients/${id}/`;
  const response = await httpManager.put(url, body);
  return response.data;
}
